import { ActionReducerMap, createReducer, on } from '@ngrx/store';
import * as accountsActions from '../actions/accounts.actions';
import { AccountsState } from '../accounts.state';
import { Account } from '../../models/account';
export const initialAccountsState: { list: Array<any> } = { list: [] };
export const initialAccountState: Account = null;
export const initialPaginatedAccountsState: { list: Array<any>, total: number } = { list: [], total: 0 };

export const searchAccountsReducer = createReducer(
    initialAccountsState,
    on(accountsActions.SearchAccountsSuccess, (state, action) => Object.assign({}, { list: action.list }))
);

export const getPaginatedAccountsReducer = createReducer(
    initialPaginatedAccountsState,
    on(accountsActions.GetPaginatedAccountsSuccess, (state, action) => Object.assign({}, { list: action.list, total: action.total })),
    on(accountsActions.GetAccountSuccess, (state, action) => Object.assign({}, { list: [action.account], total: 1 }))
);

export const getAccountReducer = createReducer(
    initialAccountState,
    on(accountsActions.GetAccountSuccess, (state, action) => Object.assign({}, action.account)),
    on(accountsActions.UpdateAccountSuccess, (state, action) => Object.assign({}, action.account)),
    on(accountsActions.EnableAccountSuccess, (state, action) => Object.assign({}, action.account))
);

export const reducers: ActionReducerMap<AccountsState> = {
    searchAccounts: searchAccountsReducer,
    paginatedAccounts: getPaginatedAccountsReducer,
    account: getAccountReducer
};
